module.exports = __webpack_public_path__ + "images/marketing/implement/3.png";